import { bindable } from 'aurelia';

export class ErrorComponent {
  @bindable error: string
}